import React from "react";
import { connect } from "react-redux";
import { reduxForm, Field, change, untouch, SubmissionError } from "redux-form";
import _ from "lodash";
import Title from "../../components/Layout/Title";
import { Link } from "react-router";
import { MARCA_SUPORTE_LOAD, MARCA_SUPORTE_UNLOAD } from "../../actions/Constants";
import api from "../../api/apiUtil";
import FieldNormalize from "../../components/Normalize/FieldNormalize";
import TextField from "../../components/Fields/TextField";
import { toastr } from "react-redux-toastr";
import FieldValidation from "../../components/Validation/FieldValidation";
import ReactTable from "react-table";

class MarcaModelo extends React.Component {
  constructor() {
    super();
    this.state = {
      idMarcaModelo: null,
    };
  }

  componentDidMount() {
    this.props.onListLoad(api.Vehicles.getListBrandModel());
  }

  componentWillUnmount() {
    this.props.onUnload();
  }

  editar = (value) => {
    this.setState({ idMarcaModelo: value.id });
    this.props.dispatch(change("MarcaModeloForm", "marcaModelo", value.descricao));
  };

  desativar = (value) => {
    Promise.resolve(api.Vehicles.deactivateBrandModel(value.id)).then((res) => {
      toastr.success("Sucesso", "Marca/Modelo desativado.");
      this.props.onListLoad(api.Vehicles.getListBrandModel());
    });
  };

  ativar = (value) => {
    Promise.resolve(api.Vehicles.activateBrandModel(value.id)).then((res) => {
      toastr.success("Sucesso", "Marca/Modelo ativado.");
      this.props.onListLoad(api.Vehicles.getListBrandModel());
    });
  };

  handleOnCancel = () => (ev) => {
    this.setState({ idMarcaModelo: null });
    this.props.dispatch(change("MarcaModeloForm", "marcaModelo", null));
    this.props.dispatch(untouch("MarcaModeloForm", "marcaModelo"));
  };

  formSubmit(values) {
    const errors = {};
    if (!values.marcaModelo || values.marcaModelo.trim().length === 0) {
      errors.marcaModelo = "Campo obrigatório";
    }
    if (errors && !_.isEmpty(errors)) {
      throw new SubmissionError(errors);
    }
    var props = this.props;
    var marcaModelo = {
      descricao: values.marcaModelo,
    };

    if (this.state.idMarcaModelo) {
      marcaModelo.id = this.state.idMarcaModelo;
      Promise.resolve(api.Vehicles.updateBrandModel(marcaModelo))
        .then((ret) => {
          toastr.success("Sucesso", "Marca/Modelo alterado.");
          this.props.onListLoad(api.Vehicles.getListBrandModel());
          this.setState({ idMarcaModelo: null });
          this.props.reset();
        })
        .catch(function (resp) {
          if (resp.message === "Unauthorized" || resp.message === "jwt expired") {
            api.Auth.logout();
            props.onLogout();
          } else {
            toastr.error("Erro", resp.response.body.message);
          }
        });
    } else {
      Promise.resolve(api.Vehicles.addBrandModel(marcaModelo))
        .then((ret) => {
          toastr.success("Sucesso", "Marca/Modelo cadastrado.");
          this.props.onListLoad(api.Vehicles.getListBrandModel());
          this.props.reset();
        })
        .catch(function (resp) {
          if (resp.message === "Unauthorized" || resp.message === "jwt expired") {
            api.Auth.logout();
            props.onLogout();
          } else {
            toastr.error("Erro", resp.response.body.message);
          }
        });
    }
  }

  render() {
    const { handleSubmit, reset } = this.props;
    return (
      <div>
        <Title routes={this.props.routes} params={this.props.params} description="" />
        <div className="content">
          <div className="row">
            <div className="col-lg-12">
              <div className="hpanel">
                <div className="panel-heading">Registros</div>
                <div className="panel-body">
                  <form className="form-horizontal" onSubmit={handleSubmit(this.formSubmit.bind(this))}>
                    <div className="row">
                      <div className="col-md-10">
                        <Field
                          name="marcaModelo"
                          label="Marca/Modelo"
                          component={TextField}
                          type="text"
                          required={true}
                          maxlength={150}
                          validate={[FieldValidation.required]}
                          normalize={FieldNormalize.UPPERCASE}
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12">
                        <div className="text-right">
                          <Link className="btn btn-default" onClick={this.handleOnCancel()}>
                            {" "}
                            Cancelar
                          </Link>
                          {this.state.idMarcaModelo ? (
                            <button className="btn btn-info" onClick={handleSubmit(this.formSubmit.bind(this))}>
                              Alterar
                            </button>
                          ) : (
                            <button className="btn btn-info" onClick={handleSubmit(this.formSubmit.bind(this))}>
                              Adicionar
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div className="hpanel">
                <div className="panel-body">
                  <div className="table-responsive">
                    {this.props.all && (
                      <ReactTable
                        className="-striped -highlight"
                        defaultPageSize={20}
                        data={this.props.all}
                        loadingText="Carregando..."
                        noDataText="Nenhuma Informação encontrada"
                        rowsText="linhas"
                        showPageSizeOptions={false}
                        minRows={1}
                        showPagination={true}
                        previousText="Anterior"
                        nextText="Próximo"
                        pageText="página"
                        ofText="de"
                        defaultFilterMethod={this.filterMethod}
                        filterable
                        columns={[
                          {
                            Header: "Marca/Modelo",
                            accessor: "descricao",
                            headerClassName: "font-extra-bold",
                          },
                          {
                            Header: "Ativo",
                            accessor: "ativo",
                            headerClassName: "font-extra-bold",
                            className: "align-middle text-center",
                            filterable: false,
                            width: 100,
                            Cell: (rowData) => {
                              return (
                                <div>
                                  <span>{rowData.original.ativo ? "Sim" : "Não"}</span>
                                  <br />
                                </div>
                              );
                            },
                          },
                          {
                            Header: "Ação",
                            className: "align-middle text-center",
                            headerClassName: "font-extra-bold",
                            width: 190,
                            sortable: false,
                            filterable: false,
                            Cell: (row) => (
                              <div className="btn-group">
                                <button type="button" className="btn btn-sm btn-default" onClick={() => this.editar(row.original)}>
                                  <i className="far fa-edit" title="Editar"></i>
                                </button>
                                {row.original.ativo ? (
                                  <button type="button" className="btn btn-sm btn-default" onClick={() => this.desativar(row.original)}>
                                    <i className="fas fa-ban" title="Desativar"></i>
                                  </button>
                                ) : (
                                  <button type="button" className="btn btn-sm btn-default" onClick={() => this.ativar(row.original)}>
                                    <i className="far fa-check-circle" title="Ativar"></i>
                                  </button>
                                )}
                              </div>
                            ),
                          },
                        ]}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  filterMethod = (filter, row, column) => {
    const id = filter.pivotId || filter.id;
    return row[id] !== undefined ? String(row[id].toLowerCase()).includes(filter.value.toLowerCase()) : true;
  };
}

const mapDispatchToProps = (dispatch) => ({
  onListLoad: (payload) => dispatch({ type: MARCA_SUPORTE_LOAD, payload }),
  onUnload: (payload) => dispatch({ type: MARCA_SUPORTE_UNLOAD, payload }),
});

const mapStateToProps = (state) => ({
  ...state.marcaModelo,
  currentUser: state.common.currentUser,
});

const form = reduxForm({
  form: "MarcaModeloForm",
});

export default connect(mapStateToProps, mapDispatchToProps)(form(MarcaModelo));
